import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { getSystemSettings } from "@/api/system_settings";
import type { SystemSettingsView } from "@/types/api";

/** Настройки инсталляции для страниц секций.
 *
 * Ключ кэша один на все страницы и карточки: карточки пишут частичным телом и
 * инвалидируют тот же `["system-settings"]`, поэтому второй ключ означал бы
 * страницу, показывающую несохранённое старое значение. */
export function useSystemSettingsQuery(): UseQueryResult<SystemSettingsView> {
  return useQuery({ queryKey: ["system-settings"], queryFn: getSystemSettings });
}
